// React import not needed with React 19+ JSX transform
import { Input } from "@/components/ui/input";
import type { FieldConfig } from "../types";

interface TextFieldProps<T> {
  field: FieldConfig<T>;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
}

export function TextField<T>({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  id,
  placeholder,
  "aria-describedby": ariaDescribedBy,
  "aria-invalid": ariaInvalid,
}: TextFieldProps<T>) {
  return (
    <Input
      id={id}
      placeholder={placeholder}
      disabled={disabled}
      aria-describedby={ariaDescribedBy}
      aria-required={field.required || undefined}
      aria-invalid={ariaInvalid}
      autoComplete={field.autoComplete}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
